import asArray from 'utils/arrays/asArray.util';
import logger from 'utils/logger.util';
import parseMoney from 'utils/parsers/parseMoney.util';
import isFullArray from 'utils/predicates/array/isFullArray.util';

const L = logger('reduceInitDepositSuccess'); // eslint-disable-line no-unused-vars

const calculateNewDepositsDataAndTotalUsed = (options) => {
  let total = 0;

  // TODO: use .reduce() instead of .map() to pass both the total and the list
  const depositListData = asArray(options.oldDepositListData).map((oldDeposit) => {
    const newDeposit = { ...oldDeposit };

    let subtotal = 0;

    for (const { amount, clientId, source } of Object.values(options?.depositCreatedForCheckout)) {
      if (clientId !== newDeposit.clientId || source !== newDeposit.source) continue;

      subtotal += amount;
      newDeposit.selected = true; // maybe selected only if it is the first? e.g. i === 0;
      newDeposit.depositType = 'used'; // TODO: check if there is connection to DEPOSIT_TYPE
    }

    const { coin } = parseMoney({ value: subtotal });
    total += coin.num;

    newDeposit.use_deposit = coin.num;
    newDeposit.use_deposit_string = coin.str;

    return newDeposit;
  });

  return { depositListData, total };
};

const reduceInitDepositSuccess = (state, action) => {
  const oldDepositListData = state?.data?.depositListData;
  const hasOldDeposits = isFullArray(oldDepositListData);

  const hasAppointments = isFullArray(state?.appointments);
  const depositCreatedForCheckout = { ...(state?.depositCreatedForCheckout ?? {}) };
  const currentDeposit = { ...(action?.response ?? {}) };

  const createdForAppointmentId = currentDeposit.created_for_appointmentId;
  if (hasAppointments && !depositCreatedForCheckout[createdForAppointmentId]) {
    depositCreatedForCheckout[createdForAppointmentId] = currentDeposit;
  }

  if (!hasOldDeposits) {
    return { ...state, depositCreatedForCheckout };
  }

  const options = { oldDepositListData, depositCreatedForCheckout };
  const result = calculateNewDepositsDataAndTotalUsed(options);

  return {
    ...(state ?? {}),
    depositCreatedForCheckout,
    data: {
      ...(state?.data ?? {}),
      balanceToPay: state?.data?.total - result?.total,
      depositListData: result?.depositListData,
    },
  };
};

// noinspection JSUnusedGlobalSymbols
export default reduceInitDepositSuccess;
